import React from 'react';
import { ArrowUp } from 'lucide-react';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-bg-light text-primary py-10 border-t border-neutral-200" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-91">
        <p className="text-text-muted text-sm font-light" data-id="element-92">
          &copy; {new Date().getFullYear()} JRP Design Inc. All Rights Reserved.
        </p>

        <button onClick={scrollToTop} className="text-text-muted hover:text-accent transition-colors" aria-label="Scroll to top" data-id="element-93">
          <ArrowUp size={18} strokeWidth={1.5} data-id="element-94" />
        </button>
      </div>
    </footer>;
}